

export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    jQuery( document ).ready( function() {
      var $target = jQuery( '.nav-mobile .menu-item-has-children' );
      $target.each( function() {
        var $this = jQuery( this );
        $this.prepend( '<span class="menu-item__dropdown"><i class="fas fa-chevron-down"></i></span>' );
      });
      $target.on( 'click', '.menu-item__dropdown', function() {
        var $this = jQuery( this );
        $this.siblings( '.sub-menu' ).slideToggle();
        $this.find( '.svg-inline--fa' ).toggleClass( 'fa-rotate-180' );
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js